import styles from './CircularProgress.module.scss';

/**
 * CircularProgress 컴포넌트
 * - 원형 로딩 스피너 (공통 아톰 컴포넌트)
 * @param {string} className - 추가 스타일 클래스
 * @param {number} size - 스피너 크기 (px)
 */
export default function CircularProgress({ className = '', size = 32 }) {
  return (
    <div
      className={`${styles.circularProgress} ${className}`}
      style={{ width: size, height: size }}
      role="status"
      aria-label="로딩 중"
    />
  );
}
